import { render, staticRenderFns } from "./LoadOnScroll.vue?vue&type=template&id=0a296afa&scoped=true&"
import script from "./LoadOnScroll.vue?vue&type=script&lang=js&"
export * from "./LoadOnScroll.vue?vue&type=script&lang=js&"
import style0 from "./LoadOnScroll.vue?vue&type=style&index=0&id=0a296afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a296afa",
  null
  
)

export default component.exports